import { Component, Input } from '@angular/core';


@Component({
    selector: 'form-group',
    template: `
        <div class="form-group" [class.is-invalid]="isInvalid">
            <ng-content select="label"></ng-content>
            <ng-content select="i.fa"></ng-content>
            <ng-content></ng-content>
            <ng-content select="small.invalid-feedback"></ng-content>
        </div>
    `,
})
export class FormGroupComponent {

    @Input() isInvalid = false;
}
